export default __webpack_public_path__ + "static/media/ThinkFinance.20023dc7691addc85a5e6057425fb736.webp";